export default __webpack_public_path__ + "static/media/icon_instagram.287a586d.svg";